import { render, staticRenderFns } from "./DatosConvenios.vue?vue&type=template&id=29168bca&scoped=true"
import script from "./DatosConvenios.vue?vue&type=script&lang=js"
export * from "./DatosConvenios.vue?vue&type=script&lang=js"
import style0 from "./DatosConvenios.vue?vue&type=style&index=0&id=29168bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29168bca",
  null
  
)

export default component.exports